import dayjs from "dayjs";

export const dateFormat = (value, fmt) => {
    return dayjs(value).format(fmt)
}
export const week = (index) => {
    return ["第一周", "第二周", "第三周", "第四周", "第五周", "第六周", "第七周", "第八周"][index]
}
export const weekDay = (index) => {
    return ["一", "二", "三", "四", "五", "六", "日"][index]
}
export const numToChinese = (digit) => {
    if (digit < 0 || digit > 999999999) {
        return '数字超出范围';
    }

    const chineseNums = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
    const units = ['', '十', '百', '千', '万', '十', '百', '千', '亿'];
    const specialCases = ['十', '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九'];

    if (digit >= 10 && digit < 20) {
        return specialCases[digit - 10];
    }

    let chinese = '';
    let unitIndex = 0;

    do {
        let mod = digit % 10;
        digit = Math.floor(digit / 10);

        if (mod === 0 && chinese !== '') {
            chinese = chineseNums[mod] + chinese;
        } else {
            chinese = chineseNums[mod] + units[unitIndex] + chinese;
        }

        unitIndex++;
    } while (digit > 0);

    // 去除多余的'零'
    chinese = chinese.replace(/零+(?!零)/g, '零');
    chinese = chinese.replace(/^零|零$/g, '');

    return chinese || '零';
}